/**
 * Feedly Notifier — unofficial Feedly unread-count notifier
 *
 * Declares a single web-accessible-resource — `/images/icon128.png` — matched to every
 * origin with no `use_dynamic_url`, so the icon is loadable from any page at a fixed
 * URL. It is the extension's only exposed resource.
 *
 * Being an image, it loads through `probeImage` with no CORS grant, so it survives a
 * restrictive page CSP. A successful load is conclusive — served only when installed.
 *
 * Manifest verified against version 3.1.2.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'egikgfbhipinieabdmcpigejkaomgjgb';

export const feedlyNotifier: ExtensionDefinition = {
  id: ID,
  name: 'Feedly Notifier',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 10_000,
  notes:
    'Single WAR (images/icon128.png) exposed to every origin with no dynamic URL. ' +
    'Loads via <img> without a CORS grant and is conclusive.',
  signals: [
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load images/icon128.png via <img> — the only web-accessible resource, exposed ' +
        'to every origin; needs no CORS grant, so it works under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'images/icon128.png'),
    },
  ],
};
